'use client';

import HomeBanner from '../../../2026-wap/components/HomeBanner/HomeBanner';
import type { BannerProps } from '@/app/(home-page)/types';

/**
 * PC 首页 Hero 轮播（swipeImage2026）复用 2026-wap 的 HomeBanner 渲染。
 * HomeBanner 的 SPM 编码按楼块数据动态生成（C 位 `${component_id}_${id}`、
 * D 位 `banner_NN` 后缀）；B 位页面终端由 spmPage 决定，PC 必须传 home_pc，
 * 否则会沿用 HomeBanner 缺省的 home_wap（B 段错端）。
 * 本组件保留为 PC 侧组件映射入口（component-map: swipeImage2026），回调原样透传。
 */
export default function HeroBanner2026(props: BannerProps) {
  return <HomeBanner {...props} spmPage="home_pc" />;
}
